// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3mdWV","tab":"Tabs_tab__3KO1t","tabActive":"Tabs_tabActive__19GLy"};